import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/commercial-solar")({
  head: () => ({
    meta: [
      { title: "Commercial Solar in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "Commercial solar systems for warehouses, offices and multi-unit buildings across Southern California. Engineered for real ROI." },
      { property: "og:title", content: "Commercial Solar in Southern California – McKay Roofing & Solar" },
      { property: "og:description", content: "Commercial solar design and installation across Southern California." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/commercial-solar" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["commercial-solar"]} />,
});